import { closeModal, destroyModal, getModal, initModal } from '@phoenix/helpers/modal-helper';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    classes: {
      type: Array,
      default: () => [],
    },
    headerClasses: {
      type: Array,
      default: () => [],
    },
    contentClasses: {
      type: Array,
      default: () => [],
    },
    closeButtonOutside: {
      type: Boolean,
      default: false,
    },
    shouldDisplayHeader: {
      type: Boolean,
      default: true,
    },
    shouldWrapContent: {
      type: Boolean,
      default: true,
    },
    dataCy: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    naked: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Boolean,
      default: false,
    },
    headerBordered: {
      type: Boolean,
      default: true,
    },
    overflow: {
      type: Boolean,
      default: false,
    },
    overlayClasses: {
      type: Array,
      default: () => [],
    },
    default: {
      type: Boolean,
      default: false,
    },
    isClosable: {
      type: Boolean,
      default: true,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    scrollableHorizontalOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    themeDark: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      defaultOptions: {
        closable: this.isClosable,
      },
      baseClasses: ['modal'],
    };
  },

  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },

    isMedium() {
      return !this.small && !this.large && !this.fullscreen && !this.default;
    },

    _classes() {
      return [
        ...this.baseClasses,
        {
          'is-active': getModal(this.id)?._active,
          'modal--medium': this.isMedium,
          'modal--small': this.small,
          'modal--large': this.large,
          'modal--full': this.fullscreen,
          'modal--naked': this.naked,
          'modal--card': this.card,
          'modal--overflow': this.overflow,
          'modal-scrollable': this.scrollable,
          'theme-dark': this.themeDark,
          'modal-scrollable--horizontal-only': this.scrollableHorizontalOnly,
        },
        ...this.classes,
      ];
    },

    _contentClasses() {
      return ['modal__content', ...this.contentClasses];
    },

    _headerClasses() {
      return ['modal__header', { 'modal__header--bordered': this.headerBordered }, ...this.headerClasses];
    },
  },

  watch: {
    isClosable(value) {
      const modal = getModal(this.id);
      if (modal !== null) {
        modal.setClosable(value);
      }
    },
  },

  mounted() {
    initModal(this.id, {
      ...this.defaultOptions,
      ...this.options,
    });
  },

  unmounted() {
    destroyModal(this.id);
  },

  methods: {
    close() {
      closeModal(this.id);
    },
  },
};
